import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
export const getSubscriptionName = (subscription) => {
    const isBookClub = subscription.product.shape?.identifier ===
        CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.ID;
    const isDigitalService = subscription.product.shape?.identifier ===
        CRYSTALLIZE_IDS.SHAPE.PRODUCT.DIGITAL_SERVICE.ID;
    if (isBookClub || isDigitalService) {
        const productName = subscription.product.name;
        if (!productName)
            throw new Error(`Subscription has not set name - Product sku ${subscription.sku}`);
        return productName;
    }
    const name = subscription.product.components?.find(({ componentId: id }) => id === CRYSTALLIZE_IDS.SHAPE.PRODUCT.SUBSCRIPTION.NAME ||
        id === CRYSTALLIZE_IDS.SHAPE.PRODUCT.SERIES_SUBSCRIPTION.NAME)?.content;
    if (name?.__typename !== "SingleLineContent" || !name.text)
        throw new Error(`Subscription has not set name - Product sku ${subscription.sku}`);
    return name.text;
};
